<div class="modal-container d-flex flex-column h-100">
    <div class="modal-header border-0 justify-content-start">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
    </div>
    <div class="modal-body flex-grow-1 overflow-y-auto">
            <app-line-information [data]="data"></app-line-information>
    </div>
    <div class="modal-footer border-0 justify-content-end">
        <div class="m-0 d-flex">
            <app-button  [buttonType]="'button'" [button_2]="true"
            [buttonClass]="true ? 'button-primary button popup-button' : 'button-info button popup-button'"
            class="" [buttonLable]="'Exit'"
            (click)="activeModal.close({title,confirm:true})"></app-button>
        </div>
    </div>
</div>